import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLInt,
  GraphQLBoolean,
  GraphQLNonNull,
  GraphQLID,
  GraphQLFloat,
  GraphQLList
} from 'graphql';
// import GraphQLJSON from 'graphql-type-json';

import ResourceType from './resource.gql';
import CardPerformance from './cardPerformance.gql';
import Node from './node.gql';
import CourseType from './course.gql';
import QuestionAnswerType from './questionAnswerType.gql';
import QuestionForReview from './questionForReview.gql';
import BlockType from './block.gql';
import CardCompletionEnumType from './enums/cardCompletionTypeEnum.gql';

const cardType = new GraphQLObjectType({
  name: 'Card',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID)
    },
    pid: {
      type: GraphQLString
    },
    name: {
      type: GraphQLString
    },
    duration: {
      type: GraphQLFloat
    },
    description: {
      type: GraphQLString
    },
    showPeerName: {
      type: GraphQLBoolean,
      resolve: (root) => {
        const showPeerName = root.showPeerName;
        if (showPeerName === null || showPeerName === undefined || !showPeerName) {
          return false;
        }
        return true;
      }
    },
    hideAnswers: {
      type: GraphQLBoolean
    },
    autoPlay: {
      type: GraphQLBoolean,
      resolve: root => root.resource.autoPlay
    },
    autoSwitch: {
      type: GraphQLBoolean,
      resolve: (root) => {
        const autoSwitch = root.autoSwitch;
        if (autoSwitch === null || autoSwitch === undefined || autoSwitch) {
          return true;
        }
        return false;
      }
    },
    newWindow: {
      type: GraphQLBoolean,
      resolve: root => !!root.newWindow
    },
    updatedAt: {
      type: GraphQLString
    },
    resource: {
      type: ResourceType
    },
    performance: {
      type: CardPerformance,
      args: {
        userId: {
          type: GraphQLString
        }
      }
    },
    globalPosition: {
      type: GraphQLString
    },
    hidden: {
      type: GraphQLBoolean
    },
    type: {
      type: GraphQLString
    },
    minReviewCount: {
      type: GraphQLInt
    },
    currentReviewCount: {
      type: GraphQLInt
    },
    course: {
      type: CourseType
    },
    courseId: {
      type: GraphQLString
    },
    hideMarkComplete: {
      type: GraphQLBoolean
    },
    questionAnswers: {
      type: new GraphQLList(QuestionAnswerType),
      args: {
        userId: {
          type: GraphQLString
        }
      },
      resolve: item => item.questionAnswers
    },
    questionsForReview: {
      type: new GraphQLList(QuestionForReview),
      resolve: item => item.questionsForReview.slice()
    },
    reAttemptAllowed: {
      type: GraphQLBoolean,
      resolve: (root) => {
        const reAttemptAllowed = root.reAttemptAllowed;
        return !!reAttemptAllowed;
      }
    },
    reAttemptAllowedCount: {
      type: GraphQLInt
    },
    minScore: {
      type: GraphQLFloat
    },
    maxScore: {
      type: GraphQLFloat
    },
    minScaledScore: {
      type: GraphQLFloat
    },
    contributeToSuccessStatus: {
      type: GraphQLBoolean
    },
    lessStrictCompletion: {
      type: GraphQLBoolean
    },
    isGradable: {
      type: GraphQLBoolean
    },
    desktopOnly: {
      type: GraphQLBoolean
    },
    minProgressMeasure: {
      type: GraphQLFloat
    },
    blockInfo: {
      type: new GraphQLList(BlockType),
      resolve: item => (item.blockInfo ? item.blockInfo.slice() : null)
    },
    completionType: {
      type: CardCompletionEnumType
    },
    rawData: {
      type: GraphQLString
    }
    // data: {
    //   type: GraphQLJSON,
    //   resolve: (root) => {
    //     if (typeof root.rawData === 'string') {
    //       return JSON.parse(root.rawData || '{}');
    //     }
    //     return root.rawData || {};
    //   }
    // }
  }),
  interfaces: [Node.nodeInterface]
});

window[cardType.name + 'GQLType'] = cardType;

export default cardType;
